import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Add as AddIcon, TravelExplore as TravelExploreIcon } from "@mui/icons-material";
import { Box, Chip, ClickAwayListener, CircularProgress, IconButton, MenuItem, MenuList, Paper, Popper, TextField, 
// ToggleButton and ToggleButtonGroup are only used by the disabled include/exclude
// toggle below — restore both alongside it.
// ToggleButton,
// ToggleButtonGroup,
Typography, } from "@mui/material";
import { useRef, useState } from "react";
export const TextSearchFilter = ({ value, onChange, placeholder = "Add item...", onFetchSuggestions, suggestions, isFetchingSuggestions, onClearSuggestions,
// Only the disabled toggle below reads this — restore it alongside the toggle.
// The prop stays on the interface so LinkedInFilterPanel keeps passing it.
// includeOnly = false,
 }) => {
    var _a;
    const [inputValue, setInputValue] = useState("");
    // TODO: restore include/exclude once Recruiter's boolean facet dropdown can be driven
    // reliably. Today setBooleanDropdownMode fails silently and the value lands as an
    // include, so an exclusion searches for the opposite of what was asked. Details and
    // measurements in docs/recruiter-known-issues.md. To revert: restore the useState
    // below, uncomment the ToggleButtonGroup in the render, and pass includeOnly for
    // school as well as industry — neither facet offers the control in Recruiter.
    // const [mode, setMode] = useState<"include" | "exclude">("include");
    const mode = "include";
    const anchorRef = useRef(null);
    const handleAdd = () => {
        const trimmed = inputValue.trim();
        if (!trimmed)
            return;
        if (mode === "include") {
            if (!value.included.includes(trimmed)) {
                onChange(Object.assign(Object.assign({}, value), { included: [...value.included, trimmed] }));
            }
        }
        else {
            if (!value.excluded.includes(trimmed)) {
                onChange(Object.assign(Object.assign({}, value), { excluded: [...value.excluded, trimmed] }));
            }
        }
        setInputValue("");
        onClearSuggestions === null || onClearSuggestions === void 0 ? void 0 : onClearSuggestions();
    };
    const handleSelectSuggestion = (suggestion) => {
        if (mode === "include") {
            if (!value.included.includes(suggestion)) {
                onChange(Object.assign(Object.assign({}, value), { included: [...value.included, suggestion] }));
            }
        }
        else {
            if (!value.excluded.includes(suggestion)) {
                onChange(Object.assign(Object.assign({}, value), { excluded: [...value.excluded, suggestion] }));
            }
        }
        setInputValue("");
        onClearSuggestions === null || onClearSuggestions === void 0 ? void 0 : onClearSuggestions();
    };
    const handleFetchClick = () => {
        const trimmed = inputValue.trim();
        if (trimmed && onFetchSuggestions) {
            onFetchSuggestions(trimmed);
        }
    };
    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleAdd();
        }
    };
    const handleRemoveIncluded = (item) => {
        onChange(Object.assign(Object.assign({}, value), { included: value.included.filter((i) => i !== item) }));
    };
    const handleRemoveExcluded = (item) => {
        onChange(Object.assign(Object.assign({}, value), { excluded: value.excluded.filter((i) => i !== item) }));
    };
    return (_jsxs(Box, Object.assign({ sx: { display: "flex", flexDirection: "column", gap: 1.5, pt: 2 } }, { children: [_jsxs(Box, Object.assign({ ref: anchorRef }, { children: [_jsx(TextField, { size: "small", fullWidth: true, placeholder: placeholder, value: inputValue, onChange: (e) => {
                            setInputValue(e.target.value);
                            onClearSuggestions === null || onClearSuggestions === void 0 ? void 0 : onClearSuggestions();
                        }, onKeyDown: handleKeyDown, InputProps: {
                            endAdornment: (_jsxs(_Fragment, { children: [onFetchSuggestions && (_jsx(IconButton, Object.assign({ size: "small", onClick: handleFetchClick, disabled: !inputValue.trim() || isFetchingSuggestions, color: "secondary", edge: "end", title: "Look up on LinkedIn" }, { children: isFetchingSuggestions ? (_jsx(CircularProgress, { size: 16 })) : (_jsx(TravelExploreIcon, { fontSize: "small" })) }))), _jsx(IconButton, Object.assign({ size: "small", onClick: handleAdd, disabled: !inputValue.trim(), color: "primary", edge: "end" }, { children: _jsx(AddIcon, { fontSize: "small" }) }))] })),
                        }, sx: {
                            "& .MuiInputBase-input": {
                                fontSize: "13px",
                            },
                        } }), _jsx(Popper, Object.assign({ open: Boolean(suggestions && suggestions.length > 0), anchorEl: anchorRef.current, placement: "bottom-start", style: { zIndex: 1300, width: (_a = anchorRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth } }, { children: _jsx(ClickAwayListener, Object.assign({ onClickAway: () => onClearSuggestions === null || onClearSuggestions === void 0 ? void 0 : onClearSuggestions() }, { children: _jsx(Paper, Object.assign({ elevation: 3, sx: {
                                    maxHeight: 200,
                                    overflow: "auto",
                                    mt: 0.5,
                                } }, { children: _jsx(MenuList, Object.assign({ dense: true }, { children: suggestions === null || suggestions === void 0 ? void 0 : suggestions.map((s) => (_jsx(MenuItem, Object.assign({ onClick: () => handleSelectSuggestion(s), sx: { fontSize: "12px" } }, { children: s }), s))) })) })) })) })), suggestions && suggestions.length === 0 && !isFetchingSuggestions && (_jsx(Typography, Object.assign({ variant: "caption", color: "text.secondary", sx: { px: 1, py: 0.5 } }, { children: "No suggestions found" })))] })), (value.included.length > 0 || value.excluded.length > 0) && (_jsxs(Box, Object.assign({ sx: { display: "flex", flexWrap: "wrap", gap: 0.5 } }, { children: [value.included.map((item) => (_jsx(Chip, { label: item, size: "small", color: "primary", variant: "outlined", onDelete: () => handleRemoveIncluded(item), sx: { fontSize: "11px" } }, `inc-${item}`))), value.excluded.map((item) => (_jsx(Chip, { label: item, size: "small", color: "error", variant: "outlined", onDelete: () => handleRemoveExcluded(item), sx: { fontSize: "11px" } }, `exc-${item}`)))] })))] })));
};
export default TextSearchFilter;
